// extracted by mini-css-extract-plugin
export default {"list__container":"ListContainer_list__container__6UPDy"};